import React from 'react';
import { BookOpenIcon, CalendarIcon, SparklesIcon, CameraIcon } from 'lucide-react';
interface ExperienceRibbonProps {
  onNavigate: (page: string) => void;
}
export function ExperienceRibbon({
  onNavigate
}: ExperienceRibbonProps) {
  const items = [{
    icon: BookOpenIcon,
    text: 'The Menu',
    page: 'menu'
  }, {
    icon: CalendarIcon,
    text: 'Reservations',
    page: 'home' // Could link to a modal or external Resy link in a real app
  }, {
    icon: SparklesIcon,
    text: 'Private Events',
    page: 'events'
  }, {
    icon: CameraIcon,
    text: 'The Gallery',
    page: 'gallery'
  }];
  return <section className="bg-gold w-full z-20 relative" data-id="element-39">
      <div className="max-w-7xl mx-auto flex flex-wrap md:flex-nowrap h-auto md:h-[70px]" data-id="element-40">
        {items.map((item, index) => {
        const Icon = item.icon;
        return <button key={index} onClick={() => {
          onNavigate(item.page);
          window.scrollTo(0, 0);
        }} className={`
                w-1/2 md:w-1/4 py-6 md:py-0
                flex items-center justify-center gap-3 
                cursor-pointer hover:bg-black/10 transition-colors duration-300
                ${index % 2 === 0 ? 'border-r border-black/10 md:border-black/20' : ''}
                ${index < 2 ? 'border-b border-black/10 md:border-b-0' : ''}
                ${index !== 3 && index % 2 !== 0 ? 'md:border-r md:border-black/20' : ''}
              `} data-id="element-41">
              <Icon className="text-black w-4 h-4 md:w-5 md:h-5" strokeWidth={1.5} data-id="element-42" />
              <span className="text-black font-sans uppercase text-sm md:text-base tracking-widest font-semibold mt-0.5" data-id="element-43">
                {item.text}
              </span>
            </button>;
      })}
      </div>
    </section>;
}